const rtlIcons = ['car-features', 'media-next', 'media-previous', 'navigation-arrowback', 'navigation-chevronback', 'navigation-chevronforward', 'office-otherfacilityfaults', 'externallink', 'list', 'nohiddencost', 'ownersmanual', 'share'];
export const getIconSrcUrl = _ref => {
  let {
    color = 'primary',
    name,
    size = 40,
    theme
  } = _ref;

  if (!(name && theme)) {
    return '';
  }

  const isRTL = theme.direction === 'rtl';
  const iconType = `${name}-${size}`;
  const path = `${theme.iconsPath}${iconType}${isRTL && rtlIcons.includes(name) ? '-rtl' : ''}`;
  const themeMode = theme.name === 'volvo' ? 'light' : 'dark';
  return `${path}.svg#${themeMode}-${color}`;
};